import React from "react";

const SummaryCard = ({ label, value, accentColor, icon, badge, badgeBg }) => (
  <div className="summary-card">
    <div
      style={{
        position: "absolute",
        top: 0, left: 0, right: 0,
        height: "3px",
        background: accentColor,
        borderRadius: "var(--r-lg) var(--r-lg) 0 0",
        opacity: 0.7,
      }}
    />
    {icon && <span className="summary-card-icon">{icon}</span>}
    <div className="summary-label">{label}</div>
    <div className="summary-value" style={{ color: accentColor }}>{value}</div>
    {badge && (
      <span
        className="summary-card-badge"
        style={{
          background: badgeBg || accentColor + "18",
          color: accentColor,
        }}
      >
        {badge}
      </span>
    )}
  </div>
);

export default SummaryCard;
